import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRoles } from 'src/app/app.enums';
import { AuthGuard } from 'src/app/components/Guards/authGuard';
import { ConnectedArtistsComponent } from 'src/app/components/gallery-components/connected-artists/connected-artists.component';
import { GalleryConsignmentProductsComponent } from 'src/app/components/gallery-components/gallery-consignment-products/gallery-consignment-products.component';
import { GalleryProductComponent } from 'src/app/components/gallery-components/gallery-product/gallery-product.component';
import { GalleryProposalComponent } from 'src/app/components/gallery-components/gallery-proposal/gallery-proposal.component';
import { GalleryRequestedProductComponent } from 'src/app/components/gallery-components/gallery-requested-product/gallery-requested-product.component';
import { GalleryShareableProductComponent } from 'src/app/components/gallery-components/gallery-shareable-products/gallery-shareable-products.component';
import { ProposalSelectionComponent } from 'src/app/components/gallery-components/proposal-selection/proposal-selection.component';
import { ViewGalleryProductComponent } from 'src/app/components/gallery-components/view-gallery-products/view-gallery-product.component';
import { ShareableProductComponent } from 'src/app/components/shareable-product/shareable-product.component';


const routes: Routes = [
    {
        path: 'connected-artists',
        component: ConnectedArtistsComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Administrator, UserRoles.Gallery, UserRoles.GalleryStaff] }
    },
    {
        path: 'gallery-products',
        component: GalleryConsignmentProductsComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Gallery, UserRoles.GalleryStaff] }
    },
   
    {
        path: 'gallery-product/create',
        component: GalleryProductComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Gallery] }
    },
    {
        path: 'gallery-products/:Id',
        component: GalleryProductComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Gallery] }
    },
    {
        path: 'view-gallery-products',
        component: ViewGalleryProductComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Gallery] }
    },
    {
        path: 'requested-products',
        component: GalleryRequestedProductComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Gallery, UserRoles.GalleryStaff] }
    },
    {
        path: 'view-proposals',
        component: GalleryProposalComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Gallery, UserRoles.GalleryStaff] }
    },
    {
        path: 'proposal-selection/:id',
        component: ProposalSelectionComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [ UserRoles.Gallery] }
    },
    {
        path: 'gallery-shareable-product',
        component: GalleryShareableProductComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Gallery] }
    },
    {
        path: 'portfolio',
        component: ShareableProductComponent,
        canActivate: [AuthGuard],
        data: { allowedRoles: [UserRoles.Gallery] }
    },
 
   
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class GallerysRoutingModule { }
